export const ORDER_MATERIALS_LOADED = 'ORDER_MATERIALS_LOADED';
export const ORDER_MATERIALS_FORM_VALUE_CHANGED =
  'ORDER_MATERIALS_FORM_VALUE_CHANGED';
export const ORDER_MATERIALS_CONFIRMATION_MODAL_LOAD =
  'ORDER_MATERIALS_CONFIRMATION_MODAL_LOAD';
